import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { ShortLinksComponent } from "../short-links.component";
import { ModalTitleComponent } from "../../../../shared/global/modal-title/modal-title.component";


@Component({
    selector: 'app-short-link-modal',
    templateUrl: './short-link-modal.component.html',
    styleUrls: ['./short-link-modal.component.scss'],
    imports: [BaseFormModule, MatDialogModule, ShortLinksComponent, ModalTitleComponent]
})
export class ShortLinkModalComponent {
  isShowDialogTitle: boolean = true;

  constructor(
    private dialogRef: MatDialogRef<ShortLinkModalComponent>,
    private cd: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }

  onSelect(smsText) {
    this.dialogRef.close(smsText);
  }

  onClose() {
    this.dialogRef.close();
  }
}
